(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chm-hero-slider"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('chm-editorial-hero')){
customElements.define('chm-editorial-hero',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  const track=this.querySelector('[data-track]'),slides=[...this.querySelectorAll('[data-slide]')],tabs=[...this.querySelectorAll('[data-go]')],count=this.querySelector('[data-count]');
  if(!track||slides.length<2)return;
  let current=0,ticking=false;
  const fitViewport=()=>{const top=this.getBoundingClientRect().top+window.scrollY;this.style.setProperty('--chm-top',Math.round(top)+'px')};fitViewport();
  this.viewportHandler=fitViewport;window.addEventListener('resize',fitViewport);
  const sync=()=>{current=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/Math.max(track.clientWidth,1))));tabs.forEach((tab,i)=>{if(i===current)tab.setAttribute('aria-current','true');else tab.removeAttribute('aria-current')});slides.forEach((slide,i)=>{slide.inert=i!==current});count.textContent=String(current+1).padStart(2,'0')};
  const go=i=>{i=(i+slides.length)%slides.length;track.scrollTo({left:i*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})};
  this.querySelector('[data-prev]').addEventListener('click',()=>go(current-1));this.querySelector('[data-next]').addEventListener('click',()=>go(current+1));tabs.forEach((tab,i)=>tab.addEventListener('click',()=>go(i)));
  track.addEventListener('scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(()=>{sync();ticking=false})}},{passive:true});
  this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(current+(e.key==='ArrowRight'?1:-1))}});
  this.resizeObserver=new ResizeObserver(()=>{track.scrollTo({left:current*track.clientWidth,behavior:'instant'})});this.resizeObserver.observe(track);
  this.blockHandler=e=>{const slide=e.target.closest('[data-slide]');if(slides.includes(slide))go(slides.indexOf(slide))};document.addEventListener('shopify:block:select',this.blockHandler);sync();
 }
 disconnectedCallback(){this.resizeObserver?.disconnect();window.removeEventListener('resize',this.viewportHandler);document.removeEventListener('shopify:block:select',this.blockHandler);this.ready=false}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
